import { FirebaseServices } from "./config";
import { callFunction } from "./helpers";
import {
  IGetMyActivityRequest,
  IGetMyActivityResponse,
  IGetAllActivityRequest,
  IGetAllActivityResponse,
  IRecordSignOutActivityRequest,
  IRecordSignOutActivityResponse,
} from "common247";

/**
 * Retrieves the activity feed for the authenticated user.
 *
 * @param {FirebaseServices} fb Firebase services instance.
 * @param {IGetMyActivityRequest} request Activity request parameters.
 * @returns {Promise<IGetMyActivityResponse>} Activity response containing hydrated activities.
 */
export async function getMyActivity(
  fb: FirebaseServices,
  request: IGetMyActivityRequest = {}
): Promise<IGetMyActivityResponse> {
  const result = await callFunction(fb, "getMyActivityFunc", request);
  return result as IGetMyActivityResponse;
}

/**
 * Administrator function to retrieve all system-wide activity logs.
 * Requires admin privileges.
 *
 * @param {FirebaseServices} fb Firebase services instance.
 * @param {IGetAllActivityRequest} request Platform activity request parameters.
 * @returns {Promise<IGetAllActivityResponse>} Activity response containing hydrated activities.
 */
export async function getAllActivity(
  fb: FirebaseServices,
  request: IGetAllActivityRequest = {}
): Promise<IGetAllActivityResponse> {
  const result = await callFunction(fb, "getAllActivityFunc", request);
  return result as IGetAllActivityResponse;
}

/**
 * Records an explicit user sign-out event in the activity log.
 *
 * @param {FirebaseServices} fb Firebase services instance.
 * @param {IRecordSignOutActivityRequest} request Sign-out request parameters.
 * @returns {Promise<IRecordSignOutActivityResponse>} Result indicating whether event was logged.
 */
export async function recordSignOutActivity(
  fb: FirebaseServices,
  request: IRecordSignOutActivityRequest = {}
): Promise<IRecordSignOutActivityResponse> {
  const result = await callFunction(fb, "recordSignOutActivityFunc", request);
  return result as IRecordSignOutActivityResponse;
}
